const API_KEY = '992e567e43c913ea6cedbae9c8870c1e';

const BASE_URL = 'https://api.themoviedb.org/3';
const TREND_URL = `${BASE_URL}/trending/movie/week`;
const SEARCH_URL = `${BASE_URL}/search/movie`;
const MOVIE_DETAILS_URL = `${BASE_URL}/movie/`;
const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500';

export {
  API_KEY,
  BASE_URL,
  TREND_URL,
  SEARCH_URL,
  MOVIE_DETAILS_URL,
  IMAGE_BASE_URL,
};
